import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import json from 'react-syntax-highlighter/dist/esm/languages/hljs/json';
import a11yLight from 'react-syntax-highlighter/dist/esm/styles/hljs/a11y-light';

SyntaxHighlighter.registerLanguage('json', json);

import React from 'react';

import styles from './AliceAppTestPageHistoryHighlighter.module.scss';

interface Props {
    data?: string | null;
    label?: string;
    placeholder?: string;
}

export const AliceAppTestPageHistoryHighlighter: React.FC<Props> = ({ data, label, placeholder = '' }) => {
    return (
        <div>
            {label ? <h3 className={styles.aliceAppTestPageHistoryHighlighter}>{label}</h3> : null}
            <SyntaxHighlighter language="json" style={a11yLight} showLineNumbers>
                {data || placeholder}
            </SyntaxHighlighter>
        </div>
    );
};
